module.exports = __webpack_public_path__ + "static/media/Background9.4eca8759.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Backgrounds/Background9.png
// module id = 258
// module chunks = 0